<template>
  <div>
    <b-alert
      :show="!cloudflareInstalled || cloudflarePending"
      :variant="cloudflarePending ? 'light-info' : 'light-warning'"
      class="pt-4 pb-4 pr-4 pl-6 mb-6 d-flex align-items-center flex-wrap flex-md-nowrap">
      <div
        v-if="cloudflarePending"
        class="font-size-lg pr-9 mb-4 mb-md-0">
        <i class="fa fa-sm fa-hourglass-start mr-3" />
        <span>Request sent, please wait. It might take some time depending on the current queue and server load.</span>
      </div>
      <div
        v-else
        class="font-size-lg pr-9 mb-4 mb-md-0">
        <i class="fa fa-sm fa-exclamation-circle mr-3 text-warning" />
        <span>Cloudflare Proxy is not installed on this server. Do you want to send an installation request?</span>
      </div>
      <b-button
        size="sm"
        variant="outline-primary"
        :disabled="cloudflarePending"
        :class="{ 'no-events' : cloudflarePending }"
        @click="switchCloudlfare('install', selectedServerId)"
        class="ml-0 ml-md-auto text-nowrap">
        <template v-if="cloudflarePending">
          <b-spinner
            small
            variant="primary"
            class="mr-2" />
          <span>Pending Request...</span>
        </template>
        <template v-else>
          <i class="fa fa-sm fa-download" />
          <span>Install Cloudflare</span>
        </template>
      </b-button>
    </b-alert>
    <b-alert
      :show="cloudflareInstalled && !cloudflarePending"
      variant="light-success"
      class="pt-4 pb-4 pr-4 pl-6 mb-6 d-flex align-items-center flex-wrap flex-md-nowrap">
      <div class="font-size-lg pr-9 mb-4 mb-md-0">
        <i class="fa fa-sm fa-check mr-3 text-success" />
        <span>Cloudflare Proxy is active</span>
      </div>
      <b-button
        variant="transparent-danger"
        size="sm"
        v-wave
        @click="showModal('modalRemoveCloudflare')"
        class="ml-auto">
        <i class="fa fa-sm fa-trash" />
        <span>Delete Cloudflare</span>
      </b-button>
    </b-alert>
  </div>
</template>

<script>
import { SWITCH_CLOUDFLARE } from '@/core/services/store/servers.module'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'

export default {
  name: 'CloudflareStatusAlert',
  computed: {
    ...mapGetters([
      'selectedServer',
      'selectedServerId',
      'cloudflareData',
      'cloudflareInstalled',
      'cloudflarePending',
      'serversResponses',
    ]),
  },
  methods: {
    showModal(type) {
      eventBus.$emit('openModal', type)
    },

    switchCloudlfare(action, server_id) {
      this.$store.dispatch(SWITCH_CLOUDFLARE, { action, server_id })
    },
  }
}
</script>
